import { memo } from 'preact/compat';

interface Props {
    visible: boolean;
    text?: string;
    fullScreen?: boolean;
}

const LoadingOverlay = memo(({ visible, text, fullScreen = false }: Props) => {
    if (!visible) return null;

    const containerClass = fullScreen
        ? 'fixed inset-0 z-50 flex items-center justify-center bg-base-100/80'
        : 'absolute inset-0 z-10 flex items-center justify-center bg-base-100/60';

    return (
        <div className={containerClass}>
            <div className="flex flex-col items-center gap-3">
                <span className="loading loading-spinner loading-lg text-accent" />
                {text && <span className="text-sm text-base-content/70">{text}</span>}
            </div>
        </div>
    );
});

export default LoadingOverlay;
